import { ExaminerCertificationWarnings, RoutedTabs } from 'components';

export const Certification = () => {
  return (
    <>
      <ExaminerCertificationWarnings />
      <RoutedTabs
        tabsConfig={[
          { menuItem: { content: 'Speaking', icon: 'comment outline' }, path: 'speaking' },
          { menuItem: { content: 'Writing', icon: 'pencil' }, path: 'writing' },
          { menuItem: { content: 'Life Skills', icon: 'line chart' }, path: 'lifeskills' },
        ]}
      />
    </>
  );
};
